import React, { useState } from 'react';
import PropTypes from 'prop-types';
import TipModal from 'sites/views/wallet-tip-modules/wallet-tip-modal';

const Tip = ({
   isMobile,
   height,
   onModalClose,
   tipData,
   tipMe,
   isFetching,
   balance,
   topUpMyWallet,
   type,
   isFetchingWallet,
   walletData,
   animateTip,
   isAddProcessingFees,
   onChangeAddProcessingFees,
   isFetchingBalance,
   paymentButtonLoading,
   extraInfo,
   tipContentData,
   setSendPurchase,
   siteOwnerName,
}) => {
   const [selectedAmount, setSelectedAmount] = useState(extraInfo?.tip_action?.price || null);
   const [selectedWalletAmount, setSelectedWallletAmount] = useState(null);

   // useEffect(() => {
   //    if(!isFetching && !selectedAmount) {
   //       setSelectedAmount(tipData[0])
   //    }
   //    if(!isFetchingWallet && !selectedWalletAmount) {
   //       setSelectedWallletAmount(walletData[0])
   //    }
   // }, [isFetching, isFetchingWallet, selectedAmount, selectedWalletAmount, tipData, walletData])
   return (
      <TipModal
         isMobile={ isMobile }
         height={ height }
         amounts={ tipData.candidates }
         amountSettings={ tipData.custom_tip_settings }
         balance={ balance }
         type={ type }
         selectedAmount={ type === 'tip' ? selectedAmount : selectedWalletAmount }
         onSelectAmount={ type === 'tip' ? setSelectedAmount : setSelectedWallletAmount }
         onModalClose={ (arg) => {
            window.wallet_referrer_url = null
            onModalClose()
         }  }
         onClickButton={ (data, extraInfo) => {
            tipMe(data, window.wallet_referrer_url, extraInfo)
         } }
         isFetchingWallet={ isFetchingWallet }
         walletData={ walletData }
         isFetching={ isFetching }
         topUpMyWallet={ () => topUpMyWallet('top_up') }
         animate={ animateTip }
         isAddProcessingFees={ isAddProcessingFees }
         onChangeAddProcessingFees={ onChangeAddProcessingFees }
         isFetchingBalance={ isFetchingBalance }
         paymentButtonLoading={ paymentButtonLoading }
         extraInfo={ extraInfo }
         tipContentData={ tipContentData }
         setSendPurchase={ setSendPurchase }
         siteOwnerName={ siteOwnerName }
      />
   )
};

Tip.propTypes = {
   onModalClose: PropTypes.func,
   tipMe: PropTypes.func,
   topUpMyWallet: PropTypes.func,
   tipData: PropTypes.array,
   walletData: PropTypes.array,
   type: PropTypes.string,
   height: PropTypes.number,
   balance: PropTypes.number,
   isFetching: PropTypes.bool,
   isMobile: PropTypes.bool,
   isFetchingWallet: PropTypes.bool,
   animateTip: PropTypes.string,
   isAddProcessingFees: PropTypes.bool,
   onChangeAddProcessingFees: PropTypes.func,
   isFetchingBalance: PropTypes.bool,
   paymentButtonLoading: PropTypes.bool,
   extraInfo: PropTypes.object,
   tipContentData: PropTypes.object,
   setSendPurchase: PropTypes.func,
   siteOwnerName: PropTypes.string,
};

export default React.memo(Tip);
